import classnames from 'classnames'
import { useEffect, useRef, useState } from 'react'

const PAGE_INTERVAL = 10000

interface CarouselProps {
  images: string[]
}

export default function Carousel(props: CarouselProps) {
  const [activeIndex, setActiveIndex] = useState(0)
  const [hovered, setHovered] = useState(false)

  useEffect(() => {
    if (FinvizSettings.hasUserPremium || hovered) return

    const interval = setInterval(() => {
      setActiveIndex((state) => (state + 1) % props.images.length)
    }, PAGE_INTERVAL)

    return () => {
      clearInterval(interval)
    }
  }, [hovered, props.images.length])

  const onMouseEnter = useRef(() => setHovered(true))
  const onMouseLeave = useRef(() => setHovered(false))

  return (
    <div className="elite-carousel" onMouseEnter={onMouseEnter.current} onMouseLeave={onMouseLeave.current}>
      <img key={activeIndex} src={props.images[activeIndex]} alt="" />

      <div className="elite-carousel_pages" style={{ top: FinvizSettings.hasUserPremium ? 300 : 280 }}>
        {props.images.map((img, index) => (
          <span
            key={img}
            className={classnames('elite-carousel_page', {
              'is-active': activeIndex === index,
            })}
            style={{ cursor: 'pointer' }}
            onClick={() => setActiveIndex(index)}
          />
        ))}
      </div>
    </div>
  )
}
